import { MenuGroup } from "@portal/BaseComponents/Menu/type";
import { InvoiceDefaultKeys } from "./type";
import { GenericRadioOptions } from "@portal/BaseComponents/Radio/types";
import { InvoiceDerivedStatus } from "@portal/types/entities/invoice";

const customerFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Customer",
    key: "Customer",
    children: [],
  },
];
const InvoiceFilterGroups: MenuGroup[] = [
  {
    type: "group",
    label: "Invoice",
    key: "Invoice",
    children: [],
  },
];

export const invoiceFilterGroups = [
  ...customerFilterGroups,
  ...InvoiceFilterGroups,
];

export const invoiceDefaultKeys: InvoiceDefaultKeys[] = [
  "due_date_range",
  "date_range",
  "statuses",
];
export const invoiceDerivedStatusOptions: GenericRadioOptions<InvoiceDerivedStatus> =
  [
    {
      label: "All",
      value: "ALL",
    },
    { label: "Open", value: "OPEN" },
    {
      label: "Closed",
      value: "CLOSED",
    },
    {
      label: "Draft",
      value: "DRAFT",
    },
  ];
  
